(function () {
  'use strict';

  // Kischt pack buy box: singles, 3-packs and 6-packs sold from one product page.
  // Configuration comes from the JSON script inside [data-kpu-root]
  // (rendered by sections/kischt-pack-product.liquid) or window.KISCHT_PACK_CONFIG.
  // Prices, stock, variant IDs and images come from Shopify.
  // One bundle variant represents one complete pack. Quantity counts packs.

  var DEFAULTS = {
    defaultHandle: '',
    title: 'Kischt',
    shortName: 'Kischt',
    productNoun: 'Kischt product',
    unit: 'item',
    unitPlural: 'items',
    packs: [1, 3, 6],
    freeShippingThresholds: {},
    pageUpsellCount: 3,
    cartUpsellCount: 3,
    cartBundleUpsells: true,
    packPrices: {},
    bundles: [],
    products: [],
    catalog: [],
    maxQuantity: 99,
    interceptCartLinks: true,
    sizeOrder: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'],
    sizeChart: null,
    sizeChartUnit: 'in',
    includedPhotoPattern: 'front',
    upsellPhotoPattern: '',
    copy: {}
  };

  var COPY = {
    perPackLabel: 'Items per pack',
    cartUpsellsTitle: 'Add to your rotation',
    cartUpsellsText: 'Another colour for tomorrow.',
    cartBundlesTitle: 'Shop the packs',
    cartBundlesText: 'Curated colours. One size for every item.',
    emptyTitle: 'Your bag is empty',
    emptyText: 'Find your colour. Choose your fit.',
    singleFitNote: 'Choose a close, comfortable fit.',
    sizeUnavailableColour: 'This size is unavailable in this colour. Please choose another size or colour.',
    sizeUnavailableBundle: 'This size is unavailable in this pack. Choose another size or pack.'
  };

  var SIZE_ORDER = DEFAULTS.sizeOrder.slice();

  var ALIASES = {
    XXL: '2XL',
    XXXL: '3XL',
    XXXXL: '4XL',
    XXXXXL: '5XL',
    OS: 'ONESIZE',
    OSFA: 'ONESIZE',
    '2X': '2XL',
    '3X': '3XL',
    '4X': '4XL',
    '5X': '5XL'
  };

  // Display labels for canonical size keys (a one-size line uses "One Size").
  var SIZE_LABELS = { ONESIZE: 'One Size' };

  // Labels exactly as written in the template's size order (so "XS-S" or
  // "2X" show as written instead of their matching keys "XSS" or "2XL").
  var DISPLAY_LABELS = {};

  function sizeLabel(value) {
    return SIZE_LABELS[value] || DISPLAY_LABELS[value] || value;
  }

  // "Size M" for a sized line; just "One Size" for a one-size line.
  function sizePhrase(value) {
    return SIZE_LABELS[value] || 'Size ' + (DISPLAY_LABELS[value] || value);
  }

  function normaliseSize(value) {
    var s = String(value || '')
      .toUpperCase()
      .replace(/[\s-]+/g, '');

    return ALIASES[s] || s;
  }

  // Size chart text: a header row such as "Size | Bust | Bra size | Length",
  // then one row per size. A cell written as "inches ; centimetres"
  // (for example "27.5–31 ; 70–79") switches with the in/cm toggle.
  function parseSizeChart(text, caption) {
    var lines = String(text || '')
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    if (lines.length < 2) return null;

    function cells(line) {
      return line.split('|').map(function (cell) {
        return cell.trim();
      });
    }

    var header = cells(lines[0]);
    var rows = lines.slice(1).map(cells);

    var columns = header.slice(1).map(function (label, i) {
      var measured = rows.some(function (row) {
        return String(row[i + 1] || '').indexOf(';') !== -1;
      });

      return { key: 'c' + (i + 1), label: label, unitless: !measured };
    });

    return {
      caption: caption || 'Measurements',
      columns: columns,
      rows: rows.map(function (row) {
        var result = { size: row[0] };

        columns.forEach(function (column, i) {
          var cell = String(row[i + 1] || '');

          if (cell.indexOf(';') !== -1) {
            var parts = cell.split(';');
            result[column.key] = { 'in': parts[0].trim(), 'cm': String(parts[1] || '').trim() };
          } else {
            result[column.key] = cell;
          }
        });

        return result;
      })
    };
  }

  function readConfig(root) {
    var node = root.querySelector('script[data-kpu-config]');
    var inline = {};

    if (node) {
      try {
        inline = JSON.parse(node.textContent || '{}') || {};
      } catch (_) {
        inline = {};
      }
    }

    return Object.assign({}, DEFAULTS, window.KISCHT_PACK_CONFIG || {}, inline);
  }

  function start() {
    var root = document.querySelector('[data-kpu-root]');

    if (!root) return false;
    if (root.dataset.kpuReady === 'true') return true;

    root.dataset.kpuReady = 'true';

    var config = readConfig(root);
    var copy = Object.assign({}, COPY, config.copy || {});

    var rawSizeOrder =
      Array.isArray(config.sizeOrder) && config.sizeOrder.length
        ? config.sizeOrder
        : DEFAULTS.sizeOrder;

    SIZE_ORDER = rawSizeOrder.map(normaliseSize);

    rawSizeOrder.forEach(function (raw) {
      var key = normaliseSize(raw);
      if (!SIZE_LABELS[key]) DISPLAY_LABELS[key] = String(raw).trim();
    });

    // Old variant size names still map to the current ones,
    // for example { "XS-S": "S" }.
    var SIZE_ALIAS_MAP = {};

    Object.keys(config.sizeAliases || {}).forEach(function (oldName) {
      SIZE_ALIAS_MAP[normaliseSize(oldName)] = normaliseSize(config.sizeAliases[oldName]);
    });

    var PACKS = (Array.isArray(config.packs) ? config.packs : DEFAULTS.packs)
      .map(Number)
      .filter(function (n) {
        return Number.isFinite(n) && n > 0;
      });

    config.freeShippingThresholds = Object.assign(
      {},
      config.freeShippingThresholds || {}
    );

    var sizeChartDisplayUnit = /^(cm|centimetres?|centimeters?)$/i.test(
      config.sizeChartUnit
    ) ? 'cm' : 'in';

    if (!config.defaultHandle && config.products.length) {
      config.defaultHandle = config.products[0].handle;
    }

    if (!config.sizeChart && config.sizeChartText) {
      config.sizeChart = parseSizeChart(
        config.sizeChartText,
        config.sizeChartCaption
      );
    }

    var routesRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root ||
      '/';

    routesRoot = '/' + String(routesRoot).replace(/^\/+|\/+$/g, '');
    routesRoot = routesRoot === '/' ? '/' : routesRoot + '/';

    var state = {
      handle: config.defaultHandle,
      product: null,
      size: '',
      quantity: 1,
      pack: 1,
      lastHandles: { 1: config.defaultHandle },
      catalog: new Map(),
      productRequests: new Map(),
      failedHandles: new Set(),
      catalogReady: false,
      images: [],
      imageIndex: 0,
      selectionToken: 0,
      selectionTouched: false,
      cart: null,
      cartReadToken: 0,
      cartDirty: false,
      mutationBusy: false,
      currency:
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active ||
        'USD',
      upsellChoices: {
        page: new Map(),
        cart: new Map()
      },
      lastAddedSize: '',
      openers: new Map()
    };

    // Product data rendered into the page by Liquid. Anything missing is
    // fetched from /products/{handle}.js as before.
    (Array.isArray(config.catalog) ? config.catalog : []).forEach(function (p) {
      if (p && p.handle && Array.isArray(p.variants)) {
        state.catalog.set(p.handle, p);
      }
    });

    // The Single pack must always remember a colour, even when the page
    // belongs to a pack product.
    if (!colour(state.lastHandles[1]) && config.products.length) {
      state.lastHandles[1] = config.products[0].handle;
    }

    function units(count) {
      count = Number(count) || 0;
      return count + ' ' + (count === 1 ? config.unit : config.unitPlural);
    }

    function perUnit() {
      return 'per ' + config.unit;
    }

    function sizeRange() {
      if (SIZE_ORDER.length === 1) return sizeLabel(SIZE_ORDER[0]);
      return SIZE_ORDER.length
        ? sizeLabel(SIZE_ORDER[0]) + ' to ' + sizeLabel(SIZE_ORDER[SIZE_ORDER.length - 1])
        : '';
    }

    function sizesPhrase() {
      return SIZE_ORDER.length === 1
        ? sizeLabel(SIZE_ORDER[0]) + ', stretch fit'
        : 'Sizes ' + sizeRange();
    }

    function fileKey(url) {
      return String(url || '')
        .split('?')[0]
        .split('/')
        .pop()
        .toLowerCase();
    }

    // Shopify CDN resizing keeps the 2048px originals for zoom and Google.
    function sized(url, width) {
      if (!url || !width) return url || '';

      try {
        var u = new URL(url, location.origin);

        var shopifyCdn =
          /(^|\.)shopify\.com$/.test(u.hostname) ||
          /\/cdn\/shop\//.test(u.pathname);

        if (!shopifyCdn) return url;

        u.searchParams.set('width', String(width));
        return u.href;
      } catch (_) {
        return url;
      }
    }

    function srcset(url, widths) {
      return widths.map(function (w) {
        return sized(url, w) + ' ' + w + 'w';
      }).join(', ');
    }

    function el(id) {
      return root.querySelector('#' + id);
    }

    function setupMediaVideo() {
      var video = el('kpuDemoVideo');
      var toggle = el('kpuVideoToggle');
      var overlay = el('kpuVideoOverlay');

      if (!video || !toggle || !overlay) return function () {};

      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var inView = !('IntersectionObserver' in window);
      var wantsToPlay = !motion.matches;
      var userPaused = false;

      video.muted = true;
      video.defaultMuted = true;

      function updateToggle() {
        var playing = !video.paused && !video.ended;

        toggle.dataset.playing = String(playing);
        toggle.setAttribute(
          'aria-label',
          playing ? 'Pause product video' : 'Play product video'
        );
      }

      function updatePlayback() {
        if (
          wantsToPlay &&
          inView &&
          !document.hidden &&
          !root.querySelector('dialog[open]') &&
          !overlay.hidden
        ) {
          var playing = video.play();

          if (playing && typeof playing.catch === 'function') {
            playing.catch(updateToggle);
          }
        } else {
          video.pause();
        }
      }

      toggle.addEventListener('click', function () {
        wantsToPlay = video.paused;
        userPaused = !wantsToPlay;
        updatePlayback();
      });

      video.addEventListener('play', updateToggle);
      video.addEventListener('pause', updateToggle);

      video.addEventListener('error', function () {
        overlay.hidden = true;
        wantsToPlay = false;
      });

      document.addEventListener('visibilitychange', updatePlayback);

      function updateMotion() {
        wantsToPlay = !motion.matches && !userPaused;
        updatePlayback();
      }

      if (motion.addEventListener) {
        motion.addEventListener('change', updateMotion);
      } else if (motion.addListener) {
        motion.addListener(updateMotion);
      }

      if ('IntersectionObserver' in window) {
        var mediaObserver = new IntersectionObserver(
          function (entries) {
            inView = entries[0].isIntersecting;
            updatePlayback();
          },
          { threshold: 0.1 }
        );

        mediaObserver.observe(overlay);
      }

      updatePlayback();
      updateToggle();

      return updatePlayback;
    }

    var updateMediaPlayback = setupMediaVideo();
    var gallery = setupGallery();
    var stickyCart = setupStickyCart();

    function esc(value) {
      return String(value == null ? '' : value).replace(
        /[&<>"']/g,
        function (c) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
          }[c];
        }
      );
    }

    function route(path) {
      return routesRoot + String(path).replace(/^\/+/, '');
    }

    function canonicalSize(value) {
      var key = normaliseSize(value);
      return SIZE_ALIAS_MAP[key] || key;
    }

    function colour(handle) {
      return config.products.find(function (p) {
        return p.handle === handle;
      });
    }

    function bundle(handle) {
      return config.bundles.find(function (p) {
        return p.handle === handle;
      });
    }

    function selection(handle) {
      return colour(handle) || bundle(handle);
    }

    function catalogDefinitions() {
      return config.products.concat(config.bundles);
    }

    function packCount(handle) {
      var b = bundle(handle);
      return b ? b.count : 1;
    }

    // A pack can include a colour that is not sold on its own, written as
    // "Name|Plain colour|#swatch", for example "Noir|Black|#1d1b1c".
    function packOnlyColour(entry) {
      var parts = String(entry || '').split('|').map(function (part) {
        return part.trim();
      });

      if (parts.length < 2 || !parts[0]) return null;

      return {
        handle: String(entry),
        name: parts[0],
        shade: parts[1] || parts[0],
        swatch: parts[2] || '#cccccc',
        packOnly: true
      };
    }

    // Bundles may repeat a colour (for example 2 x Noir), so group them.
    function includedGroups(b) {
      var groups = [];
      var index = {};

      (b && b.colours || []).forEach(function (handle) {
        var c = colour(handle) || packOnlyColour(handle);

        if (!c) return;

        if (index[handle] === undefined) {
          index[handle] = groups.length;
          groups.push({ colour: c, quantity: 0 });
        }

        groups[index[handle]].quantity += 1;
      });

      return groups;
    }

    function includedColours(b) {
      return includedGroups(b).map(function (g) {
        return g.colour;
      });
    }

    function colourNames(b) {
      return includedGroups(b).map(function (g) {
        return (g.quantity > 1 ? g.quantity + ' x ' : '') + g.colour.shade;
      }).join(' · ');
    }

    function packProperties(handle) {
      var b = bundle(handle);

      if (!b) return null;

      var properties = {
        'Bundle': b.name,
        'Colours': colourNames(b)
      };

      properties[copy.perPackLabel] = String(b.count);

      return properties;
    }

    function cartAddItem(handle, variant, quantity) {
      var item = {
        id: variant.id,
        quantity: quantity
      };

      var properties = packProperties(handle);

      if (properties) item.properties = properties;

      return item;
    }

    function priceAmount(product, size) {
      var v = findVariant(product, size);

      if (v && Number.isFinite(Number(v.price))) {
        return Number(v.price);
      }

      var variants = product && product.variants || [];
      var available = variants.filter(buyable);

      var values = (available.length ? available : variants)
        .map(function (item) {
          return Number(item.price);
        })
        .filter(Number.isFinite);

      return values.length ? Math.min.apply(null, values) : null;
    }

    function priceForPack(count) {
      var definitions = count === 1
        ? config.products
        : config.bundles.filter(function (b) {
            return b.count === count;
          });

      var remembered = state.lastHandles[count];
      var selected = state.pack === count ? state.handle : remembered;

      var prices = definitions
        .map(function (definition) {
          return priceAmount(
            state.catalog.get(definition.handle),
            state.size
          );
        })
        .filter(function (value) {
          return value !== null;
        });

      var selectedPrice =
        selected &&
        priceAmount(state.catalog.get(selected), state.size);

      if (selectedPrice != null) {
        return { amount: selectedPrice, from: false };
      }

      if (prices.length) {
        return {
          amount: Math.min.apply(null, prices),
          from: new Set(prices).size > 1
        };
      }

      var fallback = config.packPrices[state.currency];

      return {
        amount:
          fallback && Number.isFinite(fallback[count])
            ? fallback[count]
            : null,
        from: false
      };
    }

    function renderPacks() {
      el('kpuPacks')
        .querySelectorAll('[data-kpu-pack]')
        .forEach(function (button) {
          var count = Number(button.dataset.kpuPack);
          var price = priceForPack(count);

          button.setAttribute(
            'aria-pressed',
            String(state.pack === count)
          );

          button.querySelector('.kpu-pack-price').textContent =
            price.amount === null
              ? 'Loading…'
              : (price.from ? 'From ' : '') + money(price.amount);

          button.querySelector('.kpu-pack-unit').textContent =
            price.amount === null
              ? units(count)
              : (price.from ? 'From ' : '') +
                money(price.amount / count) +
                ' ' + perUnit();

          button.disabled = state.mutationBusy;
        });
    }

    function updateQuantityLabels() {
      var b = bundle(state.handle);
      var count = b ? b.count : 1;

      el('kpuQuantityLabel').textContent =
        b ? 'Number of packs' : 'Quantity';

      el('kpuQuantity').setAttribute(
        'aria-label',
        b ? 'Number of ' + count + '-packs' : 'Quantity'
      );

      el('kpuQuantityHelp').hidden = !b;

      el('kpuQuantityHelp').textContent = b
        ? state.quantity +
          (state.quantity === 1 ? ' pack' : ' packs') +
          ' · ' +
          units(state.quantity * count) +
          ' in total'
        : '';

      if (b) {
        el('kpuBundleSizeNote').textContent = state.size
          ? 'All ' + units(count) +
            (SIZE_LABELS[state.size] ? ' are ' + SIZE_LABELS[state.size] : ' in size ' + sizeLabel(state.size)) + '.'
          : 'Choose one size for all ' + units(count) + '.';
      }
    }

    function renderBundles() {
      var focused =
        document.activeElement &&
        document.activeElement.dataset &&
        document.activeElement.dataset.kpuBundle;

      var active = bundle(state.handle);

      el('kpuSingleOptions').hidden = state.pack !== 1;
      el('kpuBundleOptions').hidden = state.pack === 1;

      if (!active) {
        updateQuantityLabels();
        return;
      }

      el('kpuBundleLabel').textContent = active.name;

      el('kpuBundles').innerHTML = config.bundles
        .filter(function (b) {
          return b.count === state.pack;
        })
        .map(function (b) {
          var p = state.catalog.get(b.handle);
          var photo = sized(productImages(p)[0], 160);

          var unavailable =
            state.failedHandles.has(b.handle) ||
            p && !productHasStock(p);

          return '<button type="button" class="kpu-bundle-card' +
            (unavailable ? ' is-unavailable' : '') +
            '" data-kpu-bundle="' + esc(b.handle) +
            '" aria-pressed="' + (state.handle === b.handle) +
            '" aria-label="' +
            esc(
              b.name + ', ' + units(b.count) + ', ' + colourNames(b) +
              (unavailable ? ', currently unavailable' : '')
            ) +
            '">' +
            (photo
              ? '<img src="' + esc(photo) +
                '" alt="" width="64" height="64" loading="lazy">'
              : '<span class="kpu-bundle-placeholder" aria-hidden="true">' +
                b.count + '</span>') +
            '<span class="kpu-bundle-card-copy"><strong>' +
            esc(b.name) +
            '</strong><span>' + esc(colourNames(b)) +
            '</span></span></button>';
        })
        .join('');

      el('kpuIncludedHeading').textContent =
        "What's included · " + units(active.count);

      var includedPattern = config.includedPhotoPattern
        ? new RegExp(config.includedPhotoPattern, 'i')
        : null;

      el('kpuBundleContents').innerHTML = includedGroups(active)
        .map(function (g) {
          var c = g.colour;
          var photos = productImages(state.catalog.get(c.handle));

          var photo = (includedPattern && photos.find(function (src) {
            return includedPattern.test(fileKey(src));
          })) || photos[0];

          return '<li>' +
            (photo
              ? '<img src="' + esc(sized(photo, 180)) +
                '" alt="' + esc(config.productNoun + ' in ' + c.name + ' ' + c.shade) +
                '" width="80" height="80" loading="lazy">'
              : '<span class="kpu-included-swatch" style="background:' +
                esc(c.swatch) + '" aria-hidden="true"></span>') +
            '<span class="kpu-included-colour">' +
            esc(c.name) +
            '</span><span class="kpu-included-quantity">' +
            esc(units(g.quantity)) +
            '</span></li>';
        })
        .join('');

      updateQuantityLabels();

      if (focused) {
        var focusTarget = Array.from(
          el('kpuBundles').querySelectorAll('[data-kpu-bundle]')
        ).find(function (button) {
          return button.dataset.kpuBundle === focused;
        });

        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
    }

    function selectPack(count) {
      if (PACKS.indexOf(count) === -1 || state.pack === count) {
        return;
      }

      var choices = count === 1
        ? config.products
        : config.bundles.filter(function (b) {
            return b.count === count;
          });

      if (!choices.length) return;

      // Keep the shopper's shade (or Nude Mix) when the pack size changes:
      // Espresso single -> Espresso 6-pack, Light Nude Mix 3-pack -> Light Nude Mix 6-pack.
      var current = config.products.concat(config.bundles).filter(function (c) {
        return c.handle === state.handle;
      })[0];

      var sameName = current && choices.filter(function (c) {
        return c.name === current.name;
      })[0];

      var handle = sameName ? sameName.handle : state.lastHandles[count];

      if (!choices.some(function (c) {
        return c.handle === handle;
      })) {
        handle = choices[0].handle;
      }

      selectColour(handle, false, true);
    }

    function money(cents, currency, short) {
      var value = Number(cents);

      if (!Number.isFinite(value)) return '';

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          {
            style: 'currency',
            currency: currency || state.currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits:
              short && value % 100 === 0 ? 0 : 2,
            maximumFractionDigits: 2
          }
        ).format(value / 100);
      } catch (_) {
        return (currency || state.currency) +
          ' ' +
          (value / 100).toFixed(2);
      }
    }

    function safeURL(value) {
      if (!value || typeof value !== 'string') return '';

      try {
        var u = new URL(
          value.indexOf('//') === 0 ? 'https:' + value : value,
          location.origin
        );

        return /^https?:$/.test(u.protocol) ? u.href : '';
      } catch (_) {
        return '';
      }
    }

    function imageURL(value) {
      return safeURL(
        typeof value === 'string'
          ? value
          : value && (value.src || value.url)
      );
    }

    function productImages(product) {
      return productPhotos(product).map(function (photo) {
        return photo.src;
      });
    }

    // Image URLs with their Shopify alt text, in media order.
    function productPhotos(product) {
      var seen = new Set();
      var photos = [];

      function add(src, alt) {
        src = imageURL(src);

        if (!src) return;

        var key = fileKey(src);

        if (seen.has(key)) return;

        seen.add(key);
        photos.push({ src: src, alt: alt || '' });
      }

      (product && product.media || []).forEach(function (m) {
        if (m && (m.media_type === 'image' || !m.media_type)) {
          add(m.src || (m.preview_image && m.preview_image.src), m.alt);
        }
      });

      (product && product.images || []).forEach(function (src) {
        add(src, '');
      });

      if (product && product.featured_image) add(product.featured_image, '');

      return photos;
    }

    function sizeIndex(product) {
      var index = (product.options || []).findIndex(function (option) {
        return /^(size|sizes|taille)$/i.test(
          String(
            typeof option === 'string' ? option : option.name
          ).trim()
        );
      });

      if (index !== -1) return index;

      var first = (product.variants || [])[0];

      if (!first) return -1;

      return (
        first.options ||
        [first.option1, first.option2, first.option3]
      ).findIndex(function (value) {
        return SIZE_ORDER.indexOf(canonicalSize(value)) !== -1;
      });
    }

    function variantSize(product, variant) {
      var index = sizeIndex(product);

      return index < 0
        ? ''
        : canonicalSize(
            (
              variant.options ||
              [variant.option1, variant.option2, variant.option3]
            )[index]
          );
    }

    function findVariant(product, size) {
      if (!product || !size) return null;

      var matches = (product.variants || []).filter(function (v) {
        return variantSize(product, v) === canonicalSize(size);
      });

      return matches.find(function (v) {
        return v.available === true;
      }) || matches[0] || null;
    }

    function buyable(variant) {
      return !!(
        variant &&
        variant.available === true &&
        Number.isFinite(Number(variant.price))
      );
    }

    function productHasStock(product) {
      return !!product && SIZE_ORDER.some(function (size) {
        return buyable(findVariant(product, size));
      });
    }

    function pricing(product, variant) {
      if (!product) return { text: 'Loading…', compare: '' };

      if (variant) {
        return {
          text: money(variant.price),
          compare:
            Number(variant.compare_at_price) > Number(variant.price)
              ? money(variant.compare_at_price)
              : ''
        };
      }

      var variants = (product.variants || []).filter(buyable);

      if (!variants.length) variants = product.variants || [];

      var prices = variants.map(function (v) {
        return Number(v.price);
      }).filter(Number.isFinite);

      if (!prices.length) return { text: 'Unavailable', compare: '' };

      var min = Math.min.apply(null, prices);
      var max = Math.max.apply(null, prices);
      var compare = Number(variants[0].compare_at_price);

      return {
        text: (min !== max ? 'From ' : '') + money(min),
        compare:
          min === max &&
          compare > min &&
          variants.every(function (v) {
            return Number(v.compare_at_price) === compare;
          })
            ? money(compare)
            : ''
      };
    }

    async function api(path, options) {
      options = options || {};

      var controller = new AbortController();

      var timer = setTimeout(function () {
        controller.abort();
      }, options.method === 'POST' ? 20000 : 12000);

      try {
        var response = await fetch(
          route(path),
          Object.assign(
            {
              credentials: 'same-origin',
              cache: 'no-store'
            },
            options,
            {
              signal: controller.signal,
              headers: Object.assign(
                { Accept: 'application/json' },
                options.body ? { 'Content-Type': 'application/json' } : {},
                options.headers || {}
              )
            }
          )
        );

        var data;

        try {
          data = await response.json();
        } catch (_) {
          throw new Error(
            'We could not read the shop response. Please refresh your bag before trying again.'
          );
        }

        if (!response.ok) {
          var error = new Error(
            typeof data.description === 'string'
              ? data.description
              : typeof data.message === 'string'
                ? data.message
                : 'The shop could not complete that update. Please try again.'
          );

          error.status = response.status;
          throw error;
        }

        return data;
      } catch (error) {
        if (error.name === 'AbortError') {
          throw new Error(
            'The shop took too long to respond. Refresh your bag before trying again.'
          );
        }

        throw error;
      } finally {
        clearTimeout(timer);
      }
    }

    function fetchProduct(handle, fresh) {
      if (fresh) {
        state.catalog.delete(handle);
        state.productRequests.delete(handle);
      }

      if (state.catalog.has(handle)) {
        return Promise.resolve(state.catalog.get(handle));
      }

      if (state.productRequests.has(handle)) {
        return state.productRequests.get(handle);
      }

      var promise = api(
        'products/' + encodeURIComponent(handle) + '.js'
      ).then(function (p) {
        if (!p || !Array.isArray(p.variants)) {
          throw new Error('Product options are unavailable.');
        }

        state.catalog.set(handle, p);
        state.failedHandles.delete(handle);

        return p;
      }).catch(function (error) {
        state.failedHandles.add(handle);
        throw error;
      }).finally(function () {
        state.productRequests.delete(handle);
      });

      state.productRequests.set(handle, promise);

      return promise;
    }

    function message(id, text, error) {
      var target = el(id);

      target.textContent = text || '';
      target.hidden = !text;
      target.classList.toggle('is-error', !!error);
      target.classList.toggle('is-success', !!text && !error);

      if (id === 'kpuMessage') {
        stickyCart.message(error ? text : '');
      }
    }

    // Desktop and mobile sticky purchase bar.
    function setupStickyCart() {
      var bar = el('kpuStickyCart');
      var button = el('kpuStickyAddToCart');

      if (!bar || !button) {
        return {
          render: function () {},
          visibility: function () {},
          message: function () {}
        };
      }

      // Cache references before moving outside page-builder containers.
      var edit = el('kpuStickyEdit');
      var photo = el('kpuStickyImage');
      var title = el('kpuStickyTitle');
      var details = el('kpuStickyDetails');
      var perPair = el('kpuStickyPerPair');
      var total = el('kpuStickyTotal');
      var label = el('kpuStickyAddLabel');
      var status = el('kpuStickyMessage');

      var host = document.createElement('div');
      var spacer = document.createElement('div');

      host.className = 'kpu-root kpu-sticky-host';
      spacer.className = 'kpu-sticky-spacer';
      spacer.setAttribute('aria-hidden', 'true');

      var styles = getComputedStyle(root);

      [
        '--kpu-cream',
        '--kpu-wine',
        '--kpu-ink',
        '--kpu-muted',
        '--kpu-line'
      ].forEach(function (name) {
        host.style.setProperty(name, styles.getPropertyValue(name));
      });

      host.appendChild(spacer);
      host.appendChild(bar);
      document.body.appendChild(host);

      var ready = false;
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function measure() {
        if (!bar.hidden) {
          var stickyHeight = Math.ceil(bar.getBoundingClientRect().height) + 'px';
          host.style.setProperty('--kpu-sticky-height', stickyHeight);
          document.documentElement.style.setProperty('--kpu-sticky-height', stickyHeight);
        }
      }

      // Keep the chat bubble clear of the sticky bar on phones.
      var bubbleStyle = document.createElement('style');
      bubbleStyle.textContent =
        '@media (max-width: 749px){body:has(#kpuStickyCart:not([hidden])) .woot-widget-bubble{' +
        'margin-bottom:calc(var(--kpu-sticky-height, 80px) - 8px) !important}}';
      document.head.appendChild(bubbleStyle);

      function visibility() {
        bar.hidden = !ready || !!root.querySelector('dialog[open]');
        if (!bar.hidden) measure();
      }

      function chooseOptions(sizesOnly) {
        var target = sizesOnly ? el('kpuSizes') : el('kpuPacks');

        var focus =
          target.querySelector(
            'button[aria-pressed="true"]:not(:disabled)'
          ) ||
          target.querySelector('button:not(:disabled)');

        target.scrollIntoView({
          behavior: motion.matches ? 'auto' : 'smooth',
          block: 'center'
        });

        if (focus) focus.focus({ preventScroll: true });
      }

      edit.addEventListener('click', function () {
        chooseOptions(false);
      });

      button.addEventListener('click', function () {
        if (button.disabled || state.mutationBusy) return;

        if (state.cartDirty) {
          openCart(button);
          return;
        }

        if (!buyable(findVariant(state.product, state.size))) {
          chooseOptions(true);
          return;
        }

        setQuantity(el('kpuQuantity').value);
        addMain(button);
      });

      photo.addEventListener('error', function () {
        photo.hidden = true;
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(measure).observe(bar);
      } else {
        window.addEventListener('resize', measure, { passive: true });
      }

      function render() {
        var selected = selection(state.handle);
        var b = bundle(state.handle);
        var variant = findVariant(state.product, state.size);
        var amount = priceAmount(state.product, state.size);
        var stock = productHasStock(state.product);
        var canBuy = buyable(variant);
        var count = packCount(state.handle);
        var pairs = count * state.quantity;
        var src = sized(productImages(state.product)[0] || '', 120);

        title.textContent = b
          ? b.name
          : selected
            ? 'Single · ' + selected.name + ' ' + selected.shade
            : config.title;

        details.textContent =
          (count > 1 ? count + '-Pack · ' : '') +
          (state.size ? sizePhrase(state.size) : 'Choose a size') +
          (state.quantity > 1 ? ' · Qty ' + state.quantity : '');

        perPair.textContent = amount === null
          ? ''
          : money(amount / count) + ' / ' + config.unit + ' · ' + state.currency;

        edit.setAttribute(
          'aria-label',
          'Change your pack, colour or size. Current selection: ' +
          title.textContent + ', ' + details.textContent
        );

        if (src !== photo.getAttribute('src')) {
          if (src) photo.src = src;
          else photo.removeAttribute('src');

          photo.hidden = !src;
        }

        label.textContent = canBuy
          ? 'Add to cart'
          : state.size
            ? 'Change size'
            : 'Choose a size';

        button.disabled =
          !state.product ||
          !stock ||
          state.mutationBusy;

        total.textContent = canBuy
          ? money(Number(variant.price) * state.quantity)
          : '';

        total.hidden =
          !canBuy ||
          state.mutationBusy ||
          state.cartDirty;

        if (!state.product) {
          label.textContent = state.failedHandles.has(state.handle)
            ? 'Product unavailable'
            : 'Loading…';
        } else if (!stock) {
          label.textContent = count > 1
            ? 'Pack sold out'
            : 'Colour sold out';
        }

        if (state.cartDirty && !state.mutationBusy) {
          label.textContent = 'Review your bag';
          button.disabled = false;
        }

        if (state.mutationBusy) {
          label.textContent = 'Updating bag…';
        }

        button.setAttribute('aria-busy', String(state.mutationBusy));

        button.setAttribute(
          'aria-label',
          label.textContent +
          (
            canBuy && !state.mutationBusy && !state.cartDirty
              ? ', ' + units(pairs) +
                ', ' + (SIZE_LABELS[state.size] || 'size ' + sizeLabel(state.size)) +
                ', ' + total.textContent + ' ' + state.currency
              : ''
          )
        );

        edit.disabled = state.mutationBusy;
        ready = true;
        visibility();
      }

      return {
        render: render,
        visibility: visibility,
        message: function (text) {
          status.textContent = text || '';
          status.hidden = !text;
          measure();
        }
      };
    }

    function mainPrice() {
      var p = pricing(
        state.product,
        findVariant(state.product, state.size)
      );

      el('kpuPrice').textContent = p.text;
      el('kpuComparePrice').textContent = p.compare;
      el('kpuComparePrice').hidden = !p.compare;
      el('kpuCurrency').textContent = state.product ? state.currency : '';

      var stockNote = el('kpuStock');

      if (stockNote) {
        stockNote.hidden = !!state.product && !productHasStock(state.product);
      }

      var count = packCount(state.handle);
      var amount = priceAmount(state.product, state.size);

      el('kpuPerPair').textContent = count === 1
        ? perUnit()
        : amount === null
          ? units(count) + ' per pack'
          : money(amount / count) + ' ' + perUnit();

      renderPacks();
    }

    function updateActions() {
      var variant = findVariant(state.product, state.size);

      var disabled =
        !buyable(variant) ||
        state.mutationBusy ||
        state.cartDirty;

      var label = !state.product
        ? 'Loading product…'
        : !state.size
          ? 'Choose a size'
          : !buyable(variant)
            ? sizePhrase(state.size) + ' unavailable'
            : 'Add to cart · ' +
              money(Number(variant.price) * state.quantity);

      if (state.pack > 1 && buyable(variant)) {
        label = 'Add ' + units(state.pack * state.quantity) +
          ' · ' +
          money(Number(variant.price) * state.quantity);
      }

      if (state.product && !productHasStock(state.product)) {
        label = state.pack > 1 ? 'Pack sold out' : 'Colour sold out';
      }

      if (state.failedHandles.has(state.handle) && !state.product) {
        label = 'Product unavailable';
      }

      if (state.cartDirty) label = 'Refresh your bag to continue';
      if (state.mutationBusy) label = 'Updating bag…';

      el('kpuAddToCart').disabled = disabled;
      el('kpuAddToCart').setAttribute(
        'aria-busy',
        String(state.mutationBusy)
      );

      el('kpuAddLabel').textContent = label;
      el('kpuAddToCart').dataset.kpuSelected = String(buyable(variant));

      el('kpuQuantityMinus').disabled =
        state.mutationBusy || state.quantity <= 1;

      el('kpuQuantityPlus').disabled =
        state.mutationBusy || state.quantity >= config.maxQuantity;

      el('kpuQuantity').disabled = state.mutationBusy;

      el('kpuPacks').querySelectorAll('button').forEach(function (button) {
        button.disabled = state.mutationBusy;
      });

      updateQuantityLabels();

      root.querySelectorAll('[data-kpu-upsell-add]').forEach(function (button) {
        var card = button.closest('[data-kpu-upsell]');
        var product = state.catalog.get(card.dataset.handle);

        var selected = buyable(
          findVariant(product, card.querySelector('select').value)
        );

        button.disabled =
          state.mutationBusy ||
          state.cartDirty ||
          !selected;

        button.dataset.kpuSelected = String(selected);
        button.setAttribute('aria-busy', String(state.mutationBusy));
      });

      root.querySelectorAll('[data-kpu-change]').forEach(function (button) {
        button.disabled =
          state.mutationBusy ||
          state.cartDirty ||
          button.dataset.limit === 'true';
      });

      var checkout = el('kpuCheckout');

      if (checkout) {
        checkout.setAttribute(
          'aria-disabled',
          String(state.mutationBusy || state.cartDirty)
        );
      }

      el('kpuRefreshCart').hidden = !state.cartDirty;
      stickyCart.render();
    }

    function renderColours() {
      var focusedColour =
        document.activeElement &&
        document.activeElement.dataset &&
        document.activeElement.dataset.kpuColour;

      el('kpuColours').innerHTML = config.products.map(function (p) {
        return '<button type="button" class="kpu-colour' +
          (state.failedHandles.has(p.handle) ? ' is-unavailable' : '') +
          '" data-kpu-colour="' + esc(p.handle) +
          '" aria-label="' + esc(p.name + ', ' + p.shade) +
          '" aria-pressed="' + (state.handle === p.handle) +
          '"><span class="kpu-swatch" style="background:' +
          esc(p.swatch) +
          '" aria-hidden="true"></span><span class="kpu-colour-name">' +
          esc(p.name) + '</span></button>';
      }).join('');

      var c = colour(state.handle);

      el('kpuColourLabel').textContent = c
        ? c.name + ' · ' + c.shade
        : 'Choose a colour';

      var picked = selection(state.handle);
      var pickedName = el('kpuSelectionName');

      if (pickedName && picked) {
        pickedName.textContent = bundle(state.handle)
          ? picked.name + ' · ' + units(picked.count)
          : picked.name + ' · ' + picked.shade;
      }

      renderBundles();
      renderPacks();

      if (focusedColour && state.pack === 1) {
        var focusTarget = Array.from(
          el('kpuColours').querySelectorAll('[data-kpu-colour]')
        ).find(function (button) {
          return button.dataset.kpuColour === focusedColour;
        });

        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
    }

    function renderSizes() {
      el('kpuSizes').innerHTML = SIZE_ORDER.map(function (size) {
        var available = buyable(findVariant(state.product, size));

        return '<button class="kpu-size" type="button" data-kpu-size="' +
          size +
          '" aria-pressed="' + (state.size === size) +
          '" aria-label="' + sizeLabel(size) +
          (available ? '' : ', unavailable') +
          '"' + (available ? '' : ' disabled') +
          '>' + sizeLabel(size) + '</button>';
      }).join('');

      el('kpuSizeLabel').textContent = state.size ? sizeLabel(state.size) : 'Choose a size';

      var unavailable =
        state.size &&
        state.product &&
        !buyable(findVariant(state.product, state.size));

      el('kpuAvailability').textContent = unavailable
        ? copy.sizeUnavailableColour
        : state.product
          ? copy.singleFitNote + ' ' + sizesPhrase() + '.'
          : '';

      if (state.pack > 1) {
        el('kpuAvailability').textContent = unavailable
          ? copy.sizeUnavailableBundle
          : state.product
            ? (SIZE_ORDER.length === 1
              ? 'Every ' + config.unit + ' in your ' + state.pack + '-pack is ' + sizeLabel(SIZE_ORDER[0]) + '.'
              : 'One size for every ' + config.unit + ' in your ' +
                state.pack + '-pack. Sizes ' + sizeRange() + '.')
            : '';
      }

      if (state.product && !productHasStock(state.product)) {
        el('kpuAvailability').textContent = state.pack > 1
          ? 'This pack is currently sold out. Please choose another pack.'
          : 'This colour is currently sold out. Please choose another colour.';
      }

      mainPrice();
      updateActions();
    }

    // Horizontal touch/trackpad carousel with mouse/pen dragging.
    function setupGallery() {
      var viewport = el('kpuGalleryViewport');
      var track = el('kpuGalleryTrack');
      var thumbs = el('kpuThumbnails');
      var count = el('kpuImageCount');
      var status = el('kpuImageStatus');
      var main = root.querySelector('.kpu-gallery-main');

      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

      var slides = [];
      var drag = null;
      var targetIndex = null;
      var lastWidth = 0;
      var scrollFrame = 0;
      var resizeFrame = 0;
      var settleTimer = 0;
      var suppressClickUntil = 0;

      function clamp(index) {
        index = Number(index);

        return Math.max(
          0,
          Math.min(
            slides.length - 1,
            Number.isFinite(index) ? Math.round(index) : 0
          )
        );
      }

      function nearest() {
        var result = 0;
        var distance = Infinity;

        slides.forEach(function (slide, index) {
          var delta = Math.abs(slide.offsetLeft - viewport.scrollLeft);

          if (delta < distance) {
            distance = delta;
            result = index;
          }
        });

        return result;
      }

      function revealThumbnail(button) {
        var a = thumbs.getBoundingClientRect();
        var b = button.getBoundingClientRect();

        if (getComputedStyle(thumbs).flexDirection === 'row') {
          if (b.left < a.left + 8) {
            thumbs.scrollLeft += b.left - a.left - 8;
          } else if (b.right > a.right - 8) {
            thumbs.scrollLeft += b.right - a.right + 8;
          }
        } else {
          if (b.top < a.top) {
            thumbs.scrollTop += b.top - a.top;
          } else if (b.bottom > a.bottom) {
            thumbs.scrollTop += b.bottom - a.bottom;
          }
        }
      }

      function sync(index, force) {
        if (!slides.length) return;

        if (!force && viewport.clientWidth !== lastWidth) {
          onResize();
          return;
        }

        index = clamp(index);

        if (!force && index === state.imageIndex) return;

        state.imageIndex = index;

        var label = (index + 1) + ' / ' + slides.length;

        if (count.textContent !== label) count.textContent = label;

        count.hidden = false;

        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', String(i !== index));

          if (Math.abs(i - index) <= 1) {
            slide.querySelector('img').loading = 'eager';
          }
        });

        thumbs.querySelectorAll('button').forEach(function (button, i) {
          button.setAttribute('aria-pressed', String(i === index));
          if (i === index) revealThumbnail(button);
        });
      }

      function releasePointer() {
        var previous = drag;

        drag = null;
        viewport.classList.remove('is-dragging');

        if (
          previous &&
          viewport.hasPointerCapture &&
          viewport.hasPointerCapture(previous.id)
        ) {
          try {
            viewport.releasePointerCapture(previous.id);
          } catch (_) {
            // Pointer already ended.
          }
        }

        return previous;
      }

      function settle() {
        clearTimeout(settleTimer);

        if (drag) return;

        if (
          slides.length &&
          viewport.clientWidth &&
          viewport.clientWidth !== lastWidth
        ) {
          onResize();
          return;
        }

        viewport.classList.remove('is-mouse-scrolling');
        targetIndex = null;

        if (slides.length && viewport.clientWidth) sync(nearest());
      }

      function goTo(index, animate) {
        if (!slides.length) return;

        releasePointer();
        clearTimeout(settleTimer);

        index = clamp(index);
        targetIndex = index;

        var left = slides[index].offsetLeft;
        var smooth = animate !== false && !motion.matches;

        if (!viewport.clientWidth) {
          sync(index, true);
          return;
        }

        if (Math.abs(viewport.scrollLeft - left) < 1) {
          sync(index, true);
          settle();
          return;
        }

        viewport.scrollTo({
          left: left,
          top: 0,
          behavior: smooth ? 'smooth' : 'auto'
        });

        if (!smooth) {
          sync(index, true);
          settle();
        } else {
          settleTimer = setTimeout(settle, 250);
        }
      }

      function clear() {
        releasePointer();
        clearTimeout(settleTimer);
        cancelAnimationFrame(scrollFrame);
        cancelAnimationFrame(resizeFrame);

        scrollFrame = 0;
        resizeFrame = 0;
        targetIndex = null;

        viewport.classList.remove('is-draggable', 'is-mouse-scrolling');

        viewport.scrollTo({
          left: 0,
          top: 0,
          behavior: 'auto'
        });

        viewport.hidden = true;

        track.replaceChildren();
        thumbs.replaceChildren();

        thumbs.scrollTop = 0;
        thumbs.scrollLeft = 0;

        slides = [];
        state.images = [];
        state.imageIndex = 0;

        count.hidden = true;
        count.textContent = '';
      }

      // Keep the slides Liquid already rendered when they match, so the
      // first photo (the LCP image) is not downloaded twice.
      function adopt(images) {
        var existing = Array.from(track.querySelectorAll('.kpu-gallery-slide'));

        if (!existing.length || existing.length !== images.length) return false;

        var matches = existing.every(function (slide, index) {
          var image = slide.querySelector('img');
          return image && image.dataset.kpuFile === fileKey(images[index].src);
        });

        if (!matches) return false;

        slides = existing;
        state.images = images.map(function (photo) {
          return photo.src;
        });

        thumbs.querySelectorAll('[data-kpu-image]').forEach(function (button, index) {
          button.setAttribute('aria-pressed', String(index === 0));
        });

        viewport.hidden = false;
        viewport.classList.toggle('is-draggable', images.length > 1);
        status.hidden = true;
        main.setAttribute('aria-busy', 'false');

        lastWidth = viewport.clientWidth;
        goTo(0, false);

        return true;
      }

      function render(images) {
        images = (images || []).map(function (photo) {
          return typeof photo === 'string' ? { src: photo, alt: '' } : photo;
        });

        if (track.dataset.kpuSsr === 'true') {
          delete track.dataset.kpuSsr;
          if (adopt(images)) return;
        }

        clear();
        state.images = images.map(function (photo) {
          return photo.src;
        });

        if (!images.length) {
          status.hidden = false;
          status.textContent = 'Product photos are currently unavailable.';
          main.setAttribute('aria-busy', 'false');
          return;
        }

        var fragment = document.createDocumentFragment();
        var c = selection(state.handle);

        slides = images.map(function (photo, index) {
          var src = photo.src;
          var slide = document.createElement('div');
          var image = document.createElement('img');

          slide.className = 'kpu-gallery-slide';
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute(
            'aria-label',
            (index + 1) + ' of ' + images.length
          );
          slide.setAttribute('aria-hidden', String(index !== 0));

          image.className = 'kpu-main-image';

          if (index === 0) image.id = 'kpuMainImage';

          image.alt = photo.alt ||
            config.productNoun +
            (c ? ' in ' + c.name : '') +
            ', photo ' +
            (index + 1);

          image.width = 1100;
          image.height = 1100;
          image.sizes = '(max-width: 989px) 100vw, 46vw';
          image.srcset = srcset(src, [600, 900, 1200, 1600]);
          image.dataset.kpuFile = fileKey(src);
          image.draggable = false;
          image.loading = index <= 1 ? 'eager' : 'lazy';
          image.decoding = 'async';

          image.setAttribute(
            'fetchpriority',
            index === 0 ? 'high' : 'auto'
          );

          image.addEventListener('error', function () {
            image.hidden = true;

            if (slide.querySelector('.kpu-image-status')) return;

            var error = document.createElement('p');
            error.className = 'kpu-image-status';
            error.textContent =
              'This photo is unavailable. Please swipe to another photo or choose a thumbnail.';

            slide.appendChild(error);
          });

          image.src = sized(src, 1200);
          slide.appendChild(image);
          fragment.appendChild(slide);

          return slide;
        });

        track.appendChild(fragment);

        thumbs.innerHTML = images.map(function (photo, index) {
          return '<button type="button" class="kpu-thumb" data-kpu-image="' +
            index +
            '" aria-label="View photo ' + (index + 1) +
            '" aria-pressed="false"><img src="' + esc(sized(photo.src, 140)) +
            '" alt="" width="60" height="60" loading="lazy" draggable="false"></button>';
        }).join('');

        viewport.hidden = false;
        viewport.classList.toggle('is-draggable', images.length > 1);
        status.hidden = true;
        main.setAttribute('aria-busy', 'false');

        lastWidth = viewport.clientWidth;
        goTo(0, false);
      }

      viewport.addEventListener('scroll', function () {
        if (!scrollFrame) {
          scrollFrame = requestAnimationFrame(function () {
            scrollFrame = 0;

            if (slides.length && viewport.clientWidth) sync(nearest());
          });
        }

        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 160);
      }, { passive: true });

      viewport.addEventListener('scrollend', function () {
        if (
          !drag &&
          (
            targetIndex === null ||
            !slides[targetIndex] ||
            Math.abs(
              viewport.scrollLeft - slides[targetIndex].offsetLeft
            ) < 2
          )
        ) {
          settle();
        }
      }, { passive: true });

      viewport.addEventListener('pointerdown', function (event) {
        if (!event.isPrimary) return;

        targetIndex = null;

        if (event.pointerType === 'touch') {
          viewport.classList.remove('is-mouse-scrolling');
          return;
        }

        if (event.button !== 0 || slides.length < 2) return;

        clearTimeout(settleTimer);

        viewport.scrollTo({
          left: viewport.scrollLeft,
          behavior: 'auto'
        });

        viewport.focus({ preventScroll: true });

        drag = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          left: viewport.scrollLeft,
          index: nearest(),
          time: performance.now(),
          active: false
        };

        if (viewport.setPointerCapture) {
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (_) {
            // Pointer already ended.
          }
        }
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!drag || event.pointerId !== drag.id) return;

        var dx = event.clientX - drag.x;
        var dy = event.clientY - drag.y;

        if (!drag.active) {
          if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;

          drag.active = true;
          viewport.classList.add('is-dragging', 'is-mouse-scrolling');
        }

        if (event.cancelable) event.preventDefault();

        viewport.scrollLeft = Math.max(
          0,
          Math.min(
            viewport.scrollWidth - viewport.clientWidth,
            drag.left - dx
          )
        );
      }, { passive: false });

      function endDrag(event, cancelled) {
        if (!drag || (event && event.pointerId !== drag.id)) return;

        var previous = releasePointer();

        if (!previous.active) {
          settle();
          return;
        }

        var target = nearest();

        if (!cancelled && event) {
          var dx = previous.x - event.clientX;
          var distance = Math.abs(dx);
          var duration = performance.now() - previous.time;
          var threshold = Math.min(80, viewport.clientWidth * 0.18);

          if (
            target === previous.index &&
            (
              distance >= threshold ||
              (distance >= 12 && duration < 250)
            )
          ) {
            target += dx > 0 ? 1 : -1;
          }
        }

        suppressClickUntil = performance.now() + 350;
        goTo(target, true);
      }

      viewport.addEventListener('pointerup', function (event) {
        endDrag(event, false);
      });

      viewport.addEventListener('pointercancel', function (event) {
        endDrag(event, true);
      });

      viewport.addEventListener('lostpointercapture', function (event) {
        endDrag(event, true);
      });

      window.addEventListener('blur', function () {
        endDrag(null, true);
      });

      viewport.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      viewport.addEventListener('click', function (event) {
        if (performance.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      viewport.addEventListener('wheel', function () {
        targetIndex = null;
        viewport.classList.remove('is-mouse-scrolling');
      }, { passive: true });

      viewport.addEventListener('keydown', function (event) {
        if (
          event.target !== viewport ||
          event.altKey ||
          event.ctrlKey ||
          event.metaKey ||
          !slides.length
        ) {
          return;
        }

        var index = targetIndex === null
          ? state.imageIndex
          : targetIndex;

        if (event.key === 'ArrowRight') index += 1;
        else if (event.key === 'ArrowLeft') index -= 1;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = slides.length - 1;
        else return;

        event.preventDefault();
        goTo(index, true);
      });

      function onResize() {
        cancelAnimationFrame(resizeFrame);

        resizeFrame = requestAnimationFrame(function () {
          resizeFrame = 0;

          var width = viewport.clientWidth;

          if (!width || width === lastWidth || !slides.length) return;

          lastWidth = width;

          goTo(
            targetIndex === null ? state.imageIndex : targetIndex,
            false
          );
        });
      }

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(viewport);
      } else {
        window.addEventListener('resize', onResize, { passive: true });
      }

      return {
        clear: clear,
        render: render,
        goTo: goTo
      };
    }

    function showImage(index) {
      gallery.goTo(index, true);
    }

    function renderGallery() {
      gallery.render(productPhotos(state.product));
    }

    function updateURL() {
      try {
        var url = new URL(location.href);
        var v = findVariant(state.product, state.size);

        url.searchParams.delete('product');
        url.searchParams.delete('color');

        if (state.pack > 1) {
          url.searchParams.set('pack', String(state.pack));
          url.searchParams.set('bundle', state.handle);
          url.searchParams.delete('colour');
        } else {
          url.searchParams.set('colour', state.handle);
          url.searchParams.delete('pack');
          url.searchParams.delete('bundle');
        }

        if (v) url.searchParams.set('variant', String(v.id));
        else url.searchParams.delete('variant');

        if (state.size) url.searchParams.set('size', state.size);
        else url.searchParams.delete('size');

        history.replaceState(
          history.state,
          '',
          url.pathname + url.search + url.hash
        );
      } catch (_) {
        // Some embedded preview frames disallow history changes.
      }
    }

    async function selectColour(handle, fresh, updateHistory) {
      if (!selection(handle)) return;

      var token = ++state.selectionToken;

      state.handle = handle;
      state.product = fresh ? null : state.catalog.get(handle) || null;
      state.pack = packCount(handle);
      state.lastHandles[state.pack] = handle;

      renderColours();
      renderSizes();

      if (!state.product) {
        gallery.clear();

        el('kpuImageStatus').hidden = false;
        el('kpuImageStatus').textContent = 'Loading product photos…';

        root.querySelector('.kpu-gallery-main')
          .setAttribute('aria-busy', 'true');
      }

      message('kpuMessage', '');

      try {
        var product = await fetchProduct(handle, fresh);

        if (token !== state.selectionToken) return;

        state.product = product;
        el('kpuRetryProducts').hidden = true;

        renderGallery();
        renderColours();
        renderSizes();
        renderUpsells('page');

        if (updateHistory) updateURL();
      } catch (_) {
        if (token !== state.selectionToken) return;

        el('kpuImageStatus').textContent =
          'Product photos are currently unavailable.';

        root.querySelector('.kpu-gallery-main')
          .setAttribute('aria-busy', 'false');

        message(
          'kpuMessage',
          state.pack > 1
            ? 'We could not load this bundle. Choose another bundle or reload the product options.'
            : 'We could not load this colour. Choose another colour or reload the product options.',
          true
        );

        el('kpuRetryProducts').hidden = false;

        renderColours();
        renderSizes();
      }
    }

    // Shipping is based on the actual cart subtotal.
    function shippingThreshold() {
      var threshold = config.freeShippingThresholds[state.currency];

      return Number.isFinite(threshold) && threshold > 0
        ? threshold
        : null;
    }

    function renderShipping() {
      var threshold = shippingThreshold();
      var cart = state.cart;
      var known = !!cart && !state.cartDirty;
      var total = known ? Number(cart.total_price) || 0 : 0;

      var eligible =
        threshold !== null &&
        known &&
        total >= threshold;

      var text = threshold === null
        ? 'Shipping options are confirmed at checkout.'
        : !known
          ? 'Free standard shipping on eligible orders of ' +
            money(threshold, state.currency, true) + ' or more.'
          : eligible
            ? 'Free standard shipping unlocked.'
            : total === 0
              ? 'Add ' + money(threshold, state.currency, true) +
                ' or more to your bag for free shipping.'
              : 'Add ' + money(threshold - total) +
                ' more for free shipping.';

      var html =
        '<p class="kpu-shipping-text">' + esc(text) + '</p>';

      if (threshold !== null && known) {
        var percentage = Math.max(
          0,
          Math.min(100, total / threshold * 100)
        );

        html +=
          '<div class="kpu-progress" role="progressbar"' +
          ' aria-label="Progress towards free shipping"' +
          ' aria-valuemin="0" aria-valuemax="100"' +
          ' aria-valuenow="' + Math.round(percentage) +
          '" aria-valuetext="' + esc(text) +
          '"><div class="kpu-progress-fill" style="width:' +
          percentage.toFixed(2) +
          '%"></div></div><div class="kpu-shipping-foot"><span>' +
          esc(money(total)) +
          ' in your bag</span><span>' +
          esc(money(threshold, state.currency, true)) +
          ' or more</span></div>';
      }

      root.querySelectorAll('[data-kpu-shipping]').forEach(function (node) {
        node.innerHTML = html;
      });

      root.querySelectorAll('[data-kpu-shipping-policy]').forEach(function (node) {
        node.textContent = threshold === null
          ? 'Shipping options and charges are confirmed at checkout.'
          : 'Free standard shipping on eligible orders of ' +
            money(threshold, state.currency, true) + ' ' +
            state.currency + ' or more.';
      });
    }

    function preferredSize(context) {
      if (context === 'page') return state.size;
      if (state.lastAddedSize) return state.lastAddedSize;

      var sizes = new Set();

      (state.cart && state.cart.items || []).forEach(function (item) {
        var p = state.catalog.get(item.handle);

        if (!p) return;

        var v = p.variants.find(function (variant) {
          return String(variant.id) === String(item.variant_id);
        });

        if (v) sizes.add(variantSize(p, v));
      });

      return sizes.size === 1 ? Array.from(sizes)[0] : '';
    }

    function upsellCard(c, context) {
      var product = state.catalog.get(c.handle);
      var choices = state.upsellChoices[context];

      var requestedSize = choices.has(c.handle)
        ? choices.get(c.handle)
        : preferredSize(context);

      var size = buyable(findVariant(product, requestedSize))
        ? requestedSize
        : '';

      var variant = findVariant(product, size);
      var price = pricing(product, variant);
      var photos = productImages(product);
      var count = packCount(c.handle);
      var amount = priceAmount(product, size);
      var shade = count > 1 ? colourNames(c) : c.shade;

      var upsellPattern = config.upsellPhotoPattern
        ? new RegExp(config.upsellPhotoPattern, 'i')
        : null;

      var src = (upsellPattern && photos.find(function (url) {
        return upsellPattern.test(fileKey(url));
      })) || photos[0];

      src = sized(src, 420);

      var options =
        '<option value="">Choose size</option>' +
        SIZE_ORDER.map(function (s) {
          var available = buyable(findVariant(product, s));

          return '<option value="' + s + '"' +
            (s === size ? ' selected' : '') +
            (available ? '' : ' disabled') +
            '>' + sizeLabel(s) +
            (available ? '' : ' (unavailable)') +
            '</option>';
        }).join('');

      return '<article class="kpu-upsell" data-kpu-upsell="' +
        context + '" data-handle="' + esc(c.handle) + '">' +
        (src
          ? '<img class="kpu-upsell-photo" src="' + esc(src) +
            '" alt="' + esc(config.productNoun + ', ' + c.name) +
            '" width="200" height="200" loading="lazy">'
          : '<div class="kpu-upsell-photo" aria-hidden="true"></div>') +
        '<div class="kpu-upsell-info"><h3>' +
        esc(c.name) +
        '</h3><p class="kpu-upsell-shade">' +
        esc(shade) +
        '</p><div class="kpu-upsell-price" data-kpu-upsell-price>' +
        (price.compare ? '<s>' + esc(price.compare) + '</s>' : '') +
        esc(price.text) +
        '</div>' +
        (count > 1
          ? '<p class="kpu-upsell-per-pair">' +
            count + '-Pack · ' +
            (amount === null
              ? ''
              : esc(money(amount / count)) + ' ' + esc(perUnit())) +
            '</p>'
          : '') +
        '<div class="kpu-upsell-actions">' +
        '<select class="kpu-upsell-select" aria-label="Size for ' +
        esc(config.shortName + ' ' + c.name) + '">' + options +
        '</select><button class="kpu-upsell-add" type="button"' +
        ' data-kpu-upsell-add aria-label="Add ' +
        esc(config.shortName + ' ' + c.name) + ' to bag"' +
        (
          buyable(variant) && !state.mutationBusy && !state.cartDirty
            ? ''
            : ' disabled'
        ) +
        '>Add</button></div></div></article>';
    }

    function upsellHTML(context) {
      var excluded = new Set(
        context === 'page'
          ? [state.handle]
          : (state.cart && state.cart.items || []).map(function (i) {
              return i.handle;
            })
      );

      var visible = config.products.filter(function (c) {
        var p = state.catalog.get(c.handle);

        return !excluded.has(c.handle) && p && productHasStock(p);
      }).slice(
        0,
        context === 'page'
          ? config.pageUpsellCount
          : config.cartUpsellCount
      );

      return visible.map(function (c) {
        return upsellCard(c, context);
      }).join('');
    }

    function cartBundleUpsellsHTML() {
      if (!config.cartBundleUpsells) return '';

      var visible = config.bundles.filter(function (b) {
        return productHasStock(state.catalog.get(b.handle));
      });

      if (!visible.length) return '';

      return '<section class="kpu-cart-bundles"' +
        ' aria-labelledby="kpuCartBundlesTitle">' +
        '<div class="kpu-bundle-upsell-heading">' +
        '<h2 id="kpuCartBundlesTitle">' + esc(copy.cartBundlesTitle) + '</h2>' +
        '<div class="kpu-carousel-controls">' +
        '<button type="button" data-kpu-bundle-scroll="-1"' +
        ' aria-controls="kpuCartBundleTrack"' +
        ' aria-label="Previous bundle">←</button>' +
        '<button type="button" data-kpu-bundle-scroll="1"' +
        ' aria-controls="kpuCartBundleTrack"' +
        ' aria-label="Next bundle">→</button>' +
        '</div></div>' +
        '<p>' + esc(copy.cartBundlesText) + '</p>' +
        '<div id="kpuCartBundleTrack" class="kpu-cart-bundle-track"' +
        ' tabindex="0" role="region"' +
        ' aria-label="Pack recommendations. Swipe or use the left and right arrow keys.">' +
        visible.map(function (b) {
          return upsellCard(b, 'cart');
        }).join('') +
        '</div></section>';
    }

    function scrollBundleUpsells(direction) {
      var track = el('kpuCartBundleTrack');

      if (!track || !track.firstElementChild) return;

      var distance =
        track.firstElementChild.getBoundingClientRect().width + 12;

      track.scrollBy({
        left: direction * distance,
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches ? 'auto' : 'smooth'
      });
    }

    function renderUpsells(context) {
      if (context !== 'page') return;

      var html = upsellHTML(context);

      el('kpuPageUpsells').hidden = !html && state.catalogReady;

      if (html || state.catalogReady) {
        el('kpuPageUpsellCards').innerHTML = html;
      }

      updateActions();
    }

    function cartItemHTML(item) {
      var src = sized(imageURL(item.featured_image || item.image), 180);
      var key = esc(item.key);

      var price = Number(
        item.final_line_price == null
          ? item.line_price
          : item.final_line_price
      );

      var original = Number(item.original_line_price || price);

      var options = (item.options_with_values || [])
        .filter(function (o) {
          return o.value && o.value !== 'Default Title';
        })
        .map(function (o) {
          return o.name + ': ' + o.value;
        })
        .join(' / ');

      if (!options && item.variant_title !== 'Default Title') {
        options = item.variant_title || '';
      }

      var props = Object.entries(item.properties || {})
        .filter(function (entry) {
          return entry[0].charAt(0) !== '_' &&
            entry[1] !== null &&
            entry[1] !== '';
        })
        .map(function (entry) {
          return '<p class="kpu-cart-properties">' +
            esc(entry[0]) + ': ' + esc(entry[1]) + '</p>';
        })
        .join('');

      var plan =
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan;

      var count = packCount(item.handle);

      var packNote = count > 1
        ? '<p class="kpu-cart-pack-note">' +
          esc(units(count)) + ' per pack · ' +
          esc(
            money(
              price / Math.max(1, Number(item.quantity)) / count
            )
          ) +
          ' ' + esc(perUnit()) + '</p>'
        : '';

      return '<article class="kpu-cart-item">' +
        (src
          ? '<img class="kpu-cart-item-image" src="' + esc(src) +
            '" width="78" height="96" alt="' +
            esc(item.product_title || item.title) + '">'
          : '<div class="kpu-cart-item-image" aria-hidden="true"></div>') +
        '<div class="kpu-cart-item-info"><h3>' +
        esc(item.product_title || item.title) +
        '</h3><p class="kpu-cart-item-variant">' +
        esc(options) +
        '</p>' + packNote + props +
        (plan
          ? '<p class="kpu-cart-plan">' + esc(plan.name) + '</p>'
          : '') +
        '<div class="kpu-cart-item-bottom">' +
        '<span class="kpu-cart-item-price">' +
        (original > price ? '<s>' + esc(money(original)) + '</s>' : '') +
        esc(money(price)) +
        '</span><div class="kpu-cart-quantity">' +
        '<button type="button" data-kpu-change="' + key +
        '" data-quantity="' + (item.quantity - 1) +
        '" data-focus-key="' + key +
        '-minus" aria-label="Decrease quantity of ' +
        esc(item.product_title || item.title) +
        '">−</button><span>' + Number(item.quantity) +
        '</span><button type="button" data-kpu-change="' +
        key + '" data-quantity="' + (item.quantity + 1) +
        '" data-focus-key="' + key +
        '-plus" data-limit="' +
        (item.quantity >= config.maxQuantity) +
        '" aria-label="Increase quantity of ' +
        esc(item.product_title || item.title) +
        '">+</button></div></div>' +
        '<button class="kpu-remove" type="button" data-kpu-change="' +
        key + '" data-quantity="0" data-focus-key="' +
        key + '-remove">Remove</button></div></article>';
    }

    function renderCart() {
      var cart = state.cart;

      if (!cart) return;

      var active = document.activeElement;
      var hadFocus = el('kpuCartBody').contains(active);
      var focusKey = active && active.dataset && active.dataset.focusKey;

      var oldBundleTrack = el('kpuCartBundleTrack');
      var bundleScroll = oldBundleTrack ? oldBundleTrack.scrollLeft : 0;

      var body = cart.items.length
        ? cart.items.map(cartItemHTML).join('')
        : '<div class="kpu-cart-empty">' +
          '<h3>' + esc(copy.emptyTitle) + '</h3>' +
          '<p>' + esc(copy.emptyText) + '</p>' +
          '<button type="button" class="kpu-primary" data-kpu-close>' +
          'Continue shopping</button></div>';

      body += cartBundleUpsellsHTML();

      var upsells = upsellHTML('cart');

      if (upsells) {
        body +=
          '<section class="kpu-cart-upsells" aria-label="Recommended colours">' +
          '<h2>' + esc(copy.cartUpsellsTitle) + '</h2>' +
          '<p>' + esc(copy.cartUpsellsText) + '</p>' +
          '<div class="kpu-cart-upsell-list">' +
          upsells + '</div></section>';
      }

      el('kpuCartBody').innerHTML = body;

      if (el('kpuCartBundleTrack')) {
        el('kpuCartBundleTrack').scrollLeft = bundleScroll;
      }

      var threshold = shippingThreshold();
      var qualifies =
        threshold !== null &&
        cart.total_price >= threshold;

      var shipping = cart.requires_shipping === false
        ? 'Not required'
        : qualifies
          ? 'Free standard shipping'
          : 'Calculated at checkout';

      el('kpuCartFooter').hidden = !cart.items.length;

      el('kpuCartFooter').innerHTML = cart.items.length
        ? '<div class="kpu-cart-total"><span>Subtotal</span><strong>' +
          esc(money(cart.total_price)) +
          ' <small class="kpu-currency">' +
          esc(state.currency) +
          '</small></strong></div>' +
          (cart.total_discount > 0
            ? '<p class="kpu-cart-saving">Discounts applied: ' +
              esc(money(cart.total_discount)) + '</p>'
            : '') +
          '<div class="kpu-cart-total"><span>Shipping</span><span>' +
          esc(shipping) +
          '</span></div>' +
          '<p class="kpu-checkout-note">' +
          'Final shipping eligibility and taxes are confirmed at checkout.' +
          '</p><a id="kpuCheckout" class="kpu-primary kpu-checkout" href="' +
          esc(route('checkout')) +
          '">Checkout</a><a class="kpu-view-cart" href="' +
          esc(route('cart')) +
          '" data-kpu-full-cart>View full cart</a>'
        : '';

      root.querySelectorAll('[data-kpu-cart-count]').forEach(function (node) {
        node.textContent = String(cart.item_count || 0);
      });

      renderShipping();
      updateActions();

      if (hadFocus && !active.isConnected && el('kpuCart').open) {
        var target = focusKey && Array.from(
          el('kpuCartBody').querySelectorAll('[data-focus-key]')
        ).find(function (node) {
          return node.dataset.focusKey === focusKey;
        });

        (
          target ||
          el('kpuCart').querySelector('[data-kpu-close]')
        ).focus({ preventScroll: true });
      }
    }

    function cartSignature(cart) {
      return (cart.items || []).map(function (item) {
        return item.key + ':' + item.quantity;
      }).join('|') + '|' + cart.total_price;
    }

    // Horizon listens for cart:update to refresh the header bubble and its own
    // cart drawer. That drawer also opens itself on cart:update when it has
    // auto-open, so auto-open is held off while this event runs: shoppers only
    // ever see this buy box's drawer.
    function notifyTheme(cart) {
      var drawers = Array.from(
        document.querySelectorAll('cart-drawer-component[auto-open]')
      );

      drawers.forEach(function (drawer) {
        drawer.removeAttribute('auto-open');
      });

      try {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'kischt-pack-buybox',
              data: {
                source: 'kischt-pack-buybox',
                itemCount: Number(cart.item_count) || 0
              }
            }
          })
        );
      } catch (_) {
        // The theme cart icon is optional.
      } finally {
        drawers.forEach(function (drawer) {
          drawer.setAttribute('auto-open', '');
        });
      }
    }

    function acceptCart(cart) {
      if (
        !cart ||
        !Array.isArray(cart.items) ||
        !Number.isFinite(Number(cart.total_price))
      ) {
        throw new Error('Your bag could not be refreshed.');
      }

      var previous = state.cart;

      state.cart = cart;
      state.cartDirty = false;
      state.currency = cart.currency || state.currency;

      renderCart();
      mainPrice();
      renderUpsells('page');

      document.dispatchEvent(
        new CustomEvent('kischt:cart:updated', {
          detail: { cart: cart }
        })
      );

      // Only real changes reach the theme. A plain refresh (page load, back
      // button) leaves the theme's header count and drawer as they are.
      var changed = previous
        ? cartSignature(previous) !== cartSignature(cart)
        : state.mutationBusy;

      if (changed && !state.themeSync) notifyTheme(cart);
    }

    async function refreshCart() {
      var token = ++state.cartReadToken;

      el('kpuCartBody').setAttribute('aria-busy', 'true');

      try {
        var cart = await api('cart.js');

        if (token !== state.cartReadToken) return false;

        acceptCart(cart);
        message('kpuCartMessage', '');

        return true;
      } catch (_) {
        if (token !== state.cartReadToken) return false;

        state.cartDirty = true;

        message(
          'kpuCartMessage',
          'We could not refresh your bag. Refresh it before making another change, or view your full cart.',
          true
        );

        if (!state.cart) {
          el('kpuCartBody').innerHTML =
            '<p class="kpu-muted">Your bag is temporarily unavailable. ' +
            '<a data-kpu-full-cart href="' + esc(route('cart')) +
            '">View your full cart</a>.</p>';
        }

        updateActions();
        renderShipping();

        return false;
      } finally {
        if (token === state.cartReadToken) {
          el('kpuCartBody').setAttribute('aria-busy', 'false');
        }
      }
    }

    function openDialog(dialog, opener) {
      if (dialog.open) return;

      state.openers.set(dialog, opener || document.activeElement);

      dialog.showModal();
      document.body.classList.add('kpu-scroll-lock');

      updateMediaPlayback();
      stickyCart.visibility();
    }

    function openCart(opener, refresh) {
      openDialog(el('kpuCart'), opener);

      if (refresh !== false && !state.mutationBusy) {
        refreshCart();
      }
    }

    async function mutateCart(path, payload, options) {
      options = options || {};

      if (state.mutationBusy || state.cartDirty) return;

      state.mutationBusy = true;
      ++state.cartReadToken;

      updateActions();
      message('kpuMessage', '');
      message('kpuCartMessage', '');

      var completed = false;

      try {
        var result = await api(path, {
          method: 'POST',
          body: JSON.stringify(payload)
        });

        completed = true;

        if (options.size) state.lastAddedSize = options.size;

        if (path === 'cart/change.js') {
          acceptCart(result);
        } else {
          // Never repeat a successful add because a later GET failed.
          var synced = await refreshCart();

          if (!synced) {
            message(
              'kpuCartMessage',
              'Your item was added. Refresh your bag to see the latest contents and total.',
              true
            );
          }
        }

        if (options.open) openCart(options.opener, false);

        if (options.addedName) {
          message(
            'kpuMessage',
            options.addedName + ' added to your bag.'
          );
        }
      } catch (error) {
        // Shopify may adjust available quantities after a stock error.
        var syncedAfterError = await refreshCart();

        var errorText = completed
          ? 'The update was saved, but your bag could not be displayed. Please refresh your bag.'
          : error.message ||
            'We could not confirm that update. Please check your bag before trying again.';

        message(
          el('kpuCart').open ? 'kpuCartMessage' : 'kpuMessage',
          errorText,
          true
        );

        if (!syncedAfterError) state.cartDirty = true;

        if (error.status === 422 && options.handle) {
          try {
            await fetchProduct(options.handle, true);

            if (state.handle === options.handle) {
              state.product = state.catalog.get(options.handle);
              renderSizes();
            }

            renderUpsells('page');
          } catch (_) {
            // Keep the cart error visible.
          }
        }
      } finally {
        state.mutationBusy = false;
        el('kpuCartBody').setAttribute('aria-busy', 'false');
        updateActions();
      }
    }

    function addMain(opener) {
      var variant = findVariant(state.product, state.size);

      if (!buyable(variant)) return;

      mutateCart(
        'cart/add.js',
        {
          items: [
            cartAddItem(state.handle, variant, state.quantity)
          ]
        },
        {
          open: true,
          opener: opener,
          size: state.size,
          handle: state.handle,
          addedName:
            config.shortName + ' ' +
            selection(state.handle).name +
            ' / ' +
            sizeLabel(state.size)
        }
      );
    }

    function addUpsell(button) {
      var card = button.closest('[data-kpu-upsell]');
      var handle = card.dataset.handle;
      var size = card.querySelector('select').value;
      var variant = findVariant(state.catalog.get(handle), size);

      if (!buyable(variant)) return;

      mutateCart(
        'cart/add.js',
        {
          items: [cartAddItem(handle, variant, 1)]
        },
        {
          open: true,
          opener: button,
          size: size,
          handle: handle,
          addedName:
            config.shortName + ' ' +
            selection(handle).name +
            ' / ' +
            sizeLabel(size)
        }
      );
    }

    function setQuantity(value) {
      state.quantity = Math.max(
        1,
        Math.min(
          config.maxQuantity,
          parseInt(value, 10) || 1
        )
      );

      el('kpuQuantity').value = String(state.quantity);
      updateActions();
    }

    // Shared sizing data for the modal and Features & fit accordion.
    // config.sizeChart = { columns: [{ key, label, unitless }], rows: [{ size, key: { in, cm } or text }] }
    function chartValue(row, column) {
      var value = row[column.key];

      if (value == null) return '';
      if (typeof value !== 'object') return String(value);

      return String(
        value[sizeChartDisplayUnit] != null && value[sizeChartDisplayUnit] !== ''
          ? value[sizeChartDisplayUnit]
          : value['in'] != null ? value['in'] : value['cm']
      );
    }

    function renderSizeChart() {
      var chart = config.sizeChart;

      if (!chart || !Array.isArray(chart.rows) || !chart.rows.length) {
        root.querySelectorAll('[data-kpu-unit-controls]').forEach(function (node) {
          node.hidden = true;
        });
        return;
      }

      var unit = sizeChartDisplayUnit;
      var columns = chart.columns || [];

      // Skip the (in)/(cm) suffix when every value already carries its unit (lb, kg, cm, feet and inches).
      function selfUnit(column) {
        return chart.rows.every(function (row) {
          return /\b(lbs?|kg|cm|in)\b|["'\u2032\u2033]/.test(chartValue(row, column));
        });
      }

      var html =
        '<table><caption>' +
        esc(chart.caption || 'Measurements') + ' in ' +
        (unit === 'in' ? 'inches' : 'centimetres') +
        '</caption><thead><tr><th scope="col">Size</th>' +
        columns.map(function (column) {
          return '<th scope="col">' + esc(column.label) +
            (column.unitless || selfUnit(column) ? '' : ' (' + unit + ')') + '</th>';
        }).join('') +
        '</tr></thead><tbody>' +
        chart.rows.map(function (row) {
          return '<tr><th scope="row">' + esc(row.size) + '</th>' +
            columns.map(function (column) {
              return '<td>' + esc(chartValue(row, column)) + '</td>';
            }).join('') +
            '</tr>';
        }).join('') +
        '</tbody></table>';

      root.querySelectorAll('[data-kpu-size-chart]').forEach(function (node) {
        node.hidden = false;
        node.innerHTML = html;
      });

      root.querySelectorAll('[data-kpu-unit-controls]').forEach(function (node) {
        node.hidden = false;
      });

      root.querySelectorAll('[data-kpu-size-unit]').forEach(function (button) {
        button.setAttribute(
          'aria-pressed',
          String(button.dataset.kpuSizeUnit === unit)
        );
      });
    }

    // Delegated product and cart controls.
    root.addEventListener('click', function (event) {
      var button = event.target.closest('button');

      if (!button || button.disabled) return;

      if (button.hasAttribute('data-kpu-size-unit')) {
        var unit = button.dataset.kpuSizeUnit;

        if (unit === 'cm' || unit === 'in') {
          sizeChartDisplayUnit = unit;
          renderSizeChart();
        }
      } else if (button.hasAttribute('data-kpu-pack')) {
        state.selectionTouched = true;
        selectPack(Number(button.dataset.kpuPack));
      } else if (button.hasAttribute('data-kpu-bundle')) {
        state.selectionTouched = true;
        selectColour(button.dataset.kpuBundle, false, true);

        var selectedBundle = Array.from(
          el('kpuBundles').querySelectorAll('[data-kpu-bundle]')
        ).find(function (node) {
          return node.dataset.kpuBundle === state.handle;
        });

        if (selectedBundle) {
          selectedBundle.focus({ preventScroll: true });
        }
      } else if (button.hasAttribute('data-kpu-bundle-scroll')) {
        scrollBundleUpsells(Number(button.dataset.kpuBundleScroll));
      } else if (button.hasAttribute('data-kpu-colour')) {
        state.selectionTouched = true;
        selectColour(button.dataset.kpuColour, false, true);

        var colourButton = el('kpuColours').querySelector(
          '[data-kpu-colour="' + state.handle + '"]'
        );

        if (colourButton) {
          colourButton.focus({ preventScroll: true });
        }
      } else if (button.hasAttribute('data-kpu-size')) {
        state.selectionTouched = true;
        state.size = button.dataset.kpuSize;

        renderSizes();
        renderUpsells('page');
        updateURL();

        var replacement = el('kpuSizes').querySelector(
          '[data-kpu-size="' + state.size + '"]'
        );

        if (replacement) replacement.focus({ preventScroll: true });
      } else if (button.hasAttribute('data-kpu-image')) {
        showImage(Number(button.dataset.kpuImage));
      } else if (button.hasAttribute('data-kpu-open-cart')) {
        openCart(button);
      } else if (button.hasAttribute('data-kpu-close')) {
        var dialog = button.closest('dialog');

        if (dialog) dialog.close();
      } else if (button.hasAttribute('data-kpu-upsell-add')) {
        addUpsell(button);
      } else if (button.hasAttribute('data-kpu-change')) {
        mutateCart('cart/change.js', {
          id: button.dataset.kpuChange,
          quantity: Number(button.dataset.quantity)
        });
      }
    });

    root.addEventListener('keydown', function (event) {
      if (
        event.target.id === 'kpuCartBundleTrack' &&
        (event.key === 'ArrowLeft' || event.key === 'ArrowRight')
      ) {
        event.preventDefault();

        scrollBundleUpsells(
          event.key === 'ArrowRight' ? 1 : -1
        );
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.id === 'kpuQuantity') {
        setQuantity(event.target.value);
      }

      var card = event.target.closest('[data-kpu-upsell]');

      if (!card || event.target.tagName !== 'SELECT') return;

      state.upsellChoices[card.dataset.kpuUpsell].set(
        card.dataset.handle,
        event.target.value
      );

      var p = pricing(
        state.catalog.get(card.dataset.handle),
        findVariant(
          state.catalog.get(card.dataset.handle),
          event.target.value
        )
      );

      card.querySelector('[data-kpu-upsell-price]').innerHTML =
        (p.compare ? '<s>' + esc(p.compare) + '</s>' : '') +
        esc(p.text);

      var unit = card.querySelector('.kpu-upsell-per-pair');

      var amount = priceAmount(
        state.catalog.get(card.dataset.handle),
        event.target.value
      );

      if (unit && amount !== null) {
        unit.textContent =
          packCount(card.dataset.handle) +
          '-Pack · ' +
          money(amount / packCount(card.dataset.handle)) +
          ' ' + perUnit();
      }

      updateActions();
    });

    root.addEventListener('click', function (event) {
      var checkout = event.target.closest('#kpuCheckout');

      if (
        checkout &&
        checkout.getAttribute('aria-disabled') === 'true'
      ) {
        event.preventDefault();
      }
    });

    el('kpuAddToCart').addEventListener('click', function () {
      setQuantity(el('kpuQuantity').value);
      addMain(this);
    });

    el('kpuQuantityMinus').addEventListener('click', function () {
      setQuantity(state.quantity - 1);
    });

    el('kpuQuantityPlus').addEventListener('click', function () {
      setQuantity(state.quantity + 1);
    });

    el('kpuFitButton').addEventListener('click', function () {
      openDialog(el('kpuFitGuide'), this);
    });

    el('kpuRetryProducts').addEventListener('click', function () {
      selectColour(state.handle, true, false);
    });

    el('kpuRefreshCart').addEventListener('click', function () {
      if (!state.mutationBusy) refreshCart();
    });

    root.querySelectorAll('dialog').forEach(function (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;

        var rect = dialog.getBoundingClientRect();

        if (
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        ) {
          dialog.close();
        }
      });

      dialog.addEventListener('close', function () {
        if (!root.querySelector('dialog[open]')) {
          document.body.classList.remove('kpu-scroll-lock');
        }

        updateMediaPlayback();
        stickyCart.visibility();

        var opener = state.openers.get(dialog);

        if (
          !root.querySelector('dialog[open]') &&
          opener &&
          opener.isConnected
        ) {
          opener.focus({ preventScroll: true });
        }
      });
    });

    root.querySelectorAll('[data-kpu-policy]').forEach(function (a) {
      a.href = route(
        'policies/' + a.dataset.kpuPolicy + '-policy'
      );
    });

    // Open this drawer for ordinary same-store cart links.
    document.addEventListener('click', function (event) {
      if (
        !config.interceptCartLinks ||
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      var link = event.target.closest('a[href]');

      if (
        !link ||
        link.hasAttribute('data-kpu-full-cart') ||
        link.target === '_blank' ||
        link.hasAttribute('download')
      ) {
        return;
      }

      try {
        var url = new URL(link.href, location.origin);

        if (
          url.origin === location.origin &&
          url.pathname.replace(/\/$/, '') ===
          route('cart').replace(/\/$/, '')
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openCart(link);
        }
      } catch (_) {
        // Ignore invalid unrelated links.
      }
    }, true);

    document.addEventListener('kischt:cart:refresh', function () {
      if (!state.mutationBusy) refreshCart();
    });

    // Keep this bag in sync when the theme's own cart drawer or another
    // section changes the cart, without echoing an event back to the theme.
    document.addEventListener('cart:update', function (event) {
      var detail = event.detail || {};

      if (detail.sourceId === 'kischt-pack-buybox' || state.mutationBusy) return;

      state.themeSync = true;

      refreshCart().finally(function () {
        state.themeSync = false;
      });
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted && !state.mutationBusy) refreshCart();
    });

    // Restore selections from product, Google Shopping or shared landing-page URLs.
    var params = new URLSearchParams(location.search);

    var queryHandle =
      params.get('bundle') ||
      params.get('colour') ||
      params.get('color') ||
      params.get('product');

    var pathHandle = location.pathname.match(/\/products\/([^/]+)/);

    if (queryHandle && selection(queryHandle)) {
      state.handle = queryHandle;
    } else if (pathHandle && selection(pathHandle[1])) {
      state.handle = pathHandle[1];
    } else {
      var requestedPack = parseInt(params.get('pack'), 10);

      var requestedBundle = config.bundles.find(function (b) {
        return b.count === requestedPack;
      });

      if (requestedBundle) state.handle = requestedBundle.handle;
    }

    if (!selection(state.handle) && config.products.length) {
      state.handle = config.products[0].handle;
    }

    state.pack = packCount(state.handle);
    state.lastHandles[state.pack] = state.handle;

    var querySize = canonicalSize(params.get('size'));

    if (SIZE_ORDER.indexOf(querySize) !== -1) {
      state.size = querySize;
    }

    // A one-size line has nothing to choose, so start with it selected.
    if (!state.size && SIZE_ORDER.length === 1) {
      state.size = SIZE_ORDER[0];
    }

    // Google Shopping links carry ?variant=. Resolve it from the inline
    // catalog straight away so the right colour, pack and size show first.
    var initialVariant = params.get('variant');

    if (initialVariant) {
      state.catalog.forEach(function (p, handle) {
        if (!selection(handle)) return;

        var match = p.variants.find(function (v) {
          return String(v.id) === initialVariant;
        });

        if (match) {
          state.handle = handle;
          state.pack = packCount(handle);
          state.lastHandles[state.pack] = handle;
          state.size = variantSize(p, match);
        }
      });
    }

    state.product = state.catalog.get(state.handle) || null;

    renderColours();
    renderSizes();
    renderShipping();
    renderSizeChart();

    refreshCart();
    selectColour(state.handle, false, false);

    Promise.allSettled(
      catalogDefinitions().map(function (c) {
        return fetchProduct(c.handle);
      })
    ).then(async function () {
      state.catalogReady = true;

      var desiredVariant = params.get('variant');

      if (desiredVariant && !state.selectionTouched) {
        var productWithVariant = Array.from(
          state.catalog.values()
        ).find(function (p) {
          return p.variants.some(function (v) {
            return String(v.id) === desiredVariant;
          });
        });

        if (productWithVariant) {
          var v = productWithVariant.variants.find(function (variant) {
            return String(variant.id) === desiredVariant;
          });

          state.size = variantSize(productWithVariant, v);

          await selectColour(
            productWithVariant.handle,
            false,
            false
          );
        }
      }

      renderColours();
      renderSizes();
      renderUpsells('page');

      if (state.cart) renderCart();
    });

    return true;
  }

  // Support page builders that insert the HTML after the script loads.
  if (!start()) {
    var observer = new MutationObserver(function () {
      if (start()) observer.disconnect();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }
})();

